
import { RotateCcwIcon } from "vue-feather-icons";
export default {
    name: "TimePickerScroll",
    components: {
        Dropdown: () => import(/* webpackChunkName: "Dropdown" */ "../../Dropdown"),
        RotateCcwIcon,
    },
    props: {
        name: { default: "" },
        value: { default: "" },
        hardReset: { default: false },
        field: { default: null }
    },
    data: () => ({
        hour: 0,
        minute: 0,
        second: 0,
        mil: 0,
        hourLimit: 23,
        minuteLimit: 59,
        secondLimit: 59,
        milLimit: 99,
        selectedField: "",
        initialValue: "00:00:00.00",
    }),
    computed: {
        time() {
            return (
                (this.hour < 10 ? "0" : "") + this.hour + ":" +
                (this.minute < 10 ? "0" : "") + this.minute + ":" +
                (this.second < 10 ? "0" : "") + this.second + '.' + 
                (this.mil < 10 ? "0" : "" ) + this.mil
            );
        },
        selection() {
            if(!(this.field && this.field.id)) return false;
            return this.$store.state.advancedSetting.userData.allSelection.root[this.field.id]
        },
        isMobile() {
            return this.$store.state.store.isMobile && (process.isClient ? window.innerWidth <= 768 : true);
        },
    },
    watch: {
        selection(val) {
            if (val) {
                this.valueToTimeVariables(val)
            }
        },
        time(val) { 
            this.$emit("input", val)
        }
    },
    created() {
        if (this.value) {
            this.valueToTimeVariables(this.value)
        }
    },
    mounted() {
        this.initialValue = this.value;
        this.$bus.$on("resetSelection", () => { this.reset() }); 
        this.$nextTick(() => {
            if (process.isClient) window.addEventListener('resize', () => {
                if (window.innerWidth <= 768) { this.$store.commit('store/updateIsMobile', true) } else { this.$store.commit('store/updateIsMobile', false) }
            })
        })
    },
    methods: {
        selectTime(time, value) {
            this[time] = value && !isNaN(value) ? parseInt(value) : 0;
        },
        valueToTimeVariables(value) {
            let second
            [this.hour = 0, this.minute = 0, second = 0] = value.split(":").map((s) => (s && !isNaN(s) ? parseFloat(s) : 0))
            this.second = Math.floor(second)
            this.mil = Math.round((second - this.second) * 100)
        },
        reset() {
            if (this.hardReset) {
                [this.hour, this.minute, this.second, this.mil] = [0, 0, 0, 0];
                return;
            }
            if (this.initialValue) {
                [this.hour = 0, this.minute = 0, this.second = 0] =
                    this.initialValue
                        .split(":")
                        .map((s) => (s && !isNaN(s) ? parseInt(s) : 0));
                this.mil = this.initialValue.split('.')[1] || 0
            }
        },
        accept() {
            this.$emit("input", this.time);
            this.close();
        },
        cancel() {
            this.reset();
            this.$emit("cancel");
            this.close();
        },
        close() {
            this.$refs.dropdown.hideDropdown();
        },
        openPicker() {
            this.$refs.dropdown.showDropdown();
        },
        togglePicker() {
            this.$refs.dropdown.toggleDropdown();
        }
    },
};
